import { useEffect, useMemo, useRef, useState } from "react";
const  ExamInstructionsModal=({ open, onAgree, onClose })=> {
  const [ack, setAck] = useState(false);
  const [hitBottom, setHitBottom] = useState(false);
  const scrollRef = useRef(null);
  // Lock background scroll while open
  useEffect(() => {
    if (!open) return;
    const original = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    return () => {
      document.body.style.overflow = original;
    };
  }, [open]);
  useEffect(() => {
    if (!open) return;
    const el = scrollRef.current;
    if (!el) return;
    const onScroll = () => {
      const atBottom = Math.ceil(el.scrollTop + el.clientHeight) >= el.scrollHeight - 2;
      setHitBottom(atBottom);
    };
    el.addEventListener("scroll", onScroll);
    // initialize once
    onScroll();
    return () => el.removeEventListener("scroll", onScroll);
  }, [open]);
  useEffect(() => {
    if (open) {
      setAck(false);
      setHitBottom(false);
    }
  }, [open]);
  const canAgree = useMemo(() => ack && hitBottom, [ack, hitBottom]);
  if (!open) return null;
  return (
    <>
      <div
        className="modal fade show"
        style={{ display: "block" }}
        role="dialog"
        aria-modal="true"
        aria-labelledby="exam-instructions-title"
        onMouseDown={(e) => {
          if (e.target === e.currentTarget && onClose) onClose();
        }}
      >
        <div className="modal-dialog modal-lg modal-dialog-centered">
          <div className="modal-content">
            {/* Header */}
            <div className="modal-header">
              <div>
                <h5 id="exam-instructions-title" className="modal-title">Exam Instructions</h5>
                <div className="small text-muted">Please read carefully. / कृपया ध्यान से पढ़ें।</div>
              </div>
              <button type="button" className="btn-close" aria-label="Close" onClick={onClose}></button>
            </div>
            {/* Legend */}
            <div className="px-3 pt-3">
              <div className="d-flex flex-wrap align-items-center gap-2 small mb-2">
                <span className="text-muted">Question Tracker Legend / प्रश्न ट्रैकर संकेत:</span>
                <span className="badge rounded-pill bg-secondary">Not Attempted (अनुत्तरित)</span>
                <span className="badge rounded-pill bg-success">Answered (उत्तरित)</span>
                <span className="badge rounded-pill bg-warning text-dark">Skipped (छोड़ा गया)</span>
              </div>
            </div>
            {/* Scrollable content */}
            <div ref={scrollRef} className="modal-body" style={{ maxHeight: "60vh", overflowY: "auto" }}>
              <ol className="ps-3">
                <li className="mb-3">
                  <span className="fw-semibold">Do not switch tabs/windows.</span> Switching away from the exam window is strictly prohibited. If you switch tabs or windows <span className="fw-semibold">three (3) times</span>, your test will be submitted automatically.
                  <div className="small text-muted mt-1"> परीक्षा के दौरान टैब/विंडो न बदलें। यदि आप <span className="fw-semibold">तीन (3) बार</span> टैब/विंडो बदलते हैं, तो आपकी परीक्षा स्वतः सबमिट हो जाएगी।</div>
                </li>
                <li className="mb-3">
                  <span className="fw-semibold">Question tracking system:</span> The question palette uses standard colors — <span className="fw-semibold">Gray</span> for <em>Not Attempted</em>, <span className="fw-semibold">Green</span> for <em>Answered</em>, and <span className="fw-semibold">Yellow</span> for <em>Skipped</em>.
                  <div className="small text-muted mt-1"> प्रश्न पैलेट मानक रंगों का उपयोग करता है — <span className="fw-semibold">ग्रे</span> = <em>अनुत्तरित</em>, <span className="fw-semibold">हरा</span> = <em>उत्तरित</em>, <span className="fw-semibold">पीला</span> = <em>छोड़ा गया</em>।</div>
                </li>
                <li className="mb-3">
                  <span className="fw-semibold">Countdown timer : </span> A timer will be visible throughout the test. You must submit before the timer expires. When time ends, you will not be able to make further changes.
                  <div className="small text-muted mt-1"> पूरी परीक्षा के दौरान एक टाइमर दिखेगा। समय समाप्त होने से पहले आपको परीक्षा सबमिट करनी होगी; समय समाप्त होने पर आगे कोई परिवर्तन संभव नहीं होगा।</div>
                </li>
                <li className="mb-3">
                  <span className="fw-semibold">Single attempt only:</span> Once you submit, the attempt is final. You cannot submit again or re‑take the exam.
                  <div className="small text-muted mt-1"> केवल एक ही प्रयास अनुमत है। एक बार सबमिट करने के बाद पुनः सबमिट करना या परीक्षा दोबारा देना संभव नहीं है।</div>
                </li>
                <li className="mb-3">
                  <span className="fw-semibold">Scoring:</span> Each question carries <span className="fw-semibold">1 mark</span>.
                  <div className="small text-muted mt-1"> प्रत्येक प्रश्न <span className="fw-semibold">1 अंक</span> का है।</div>
                </li>
                <li className="mb-3">
                  <span className="fw-semibold">No negative marking:</span> There is <span className="fw-semibold">no penalty</span> for incorrect answers or skipped questions.
                  <div className="small text-muted mt-1"> ऋणात्मक अंकन नहीं है — गलत उत्तर या छोड़े गए प्रश्नों पर कोई दंड नहीं।</div>
                </li>
                  <li className="mb-3">
                  Make sure not to back your screen or log out of your account, as doing so will lead to the exam being submitted automatically.
                  <div className="small text-muted mt-1"> सुनिश्चित करें कि आप अपनी स्क्रीन पीछे न जाएँ और अपने अकाउंट से लॉग आउट न करें, क्योंकि ऐसा करने पर परीक्षा स्वतः जमा हो जाएगी।</div>
                </li>
              </ol>
              <div className="alert alert-secondary small mb-0">
                <div className="fw-semibold mb-1">Good to know / अतिरिक्त जानकारी</div>
                <ul className="mb-0 ps-3">
                  <li>
                    Use the question palette to navigate quickly.
                    <div className="text-muted"> तेज़ नेविगेशन के लिए प्रश्न पैलेट का उपयोग करें।</div>
                  </li>
                  <li className="mt-1">
                    Ensure a stable internet connection and power backup.
                    <div className="text-muted"> स्थिर इंटरनेट कनेक्शन और पावर बैकअप सुनिश्चित करें।</div>
                  </li>
                  <li className="mt-1">
                    Do not refresh the page or use the browser back button during the exam.
                    <div className="text-muted"> परीक्षा के दौरान पेज रीफ़्रेश/ब्राउज़र बैक बटन का उपयोग न करें।</div>
                  </li>
                </ul>
              </div>
            </div>
            {/* Footer / Consent bar */}
            <div className="modal-footer d-block">
              <div className="d-flex flex-column flex-sm-column align-items-start  justify-content-between gap-2">
                <div className="form-check">
                  <input
                    className="form-check-input"
                    type="checkbox"
                    id="acknowledge"
                    checked={ack}
                    onChange={(e) => setAck(e.target.checked)}
                  />
                  <label className="form-check-label" htmlFor="acknowledge">
                    I confirm that I have read and understood all the instructions above and agree to follow them.
                    {!hitBottom && <span className="text-muted ms-1">(Scroll to the bottom to enable the button)</span>}
                    <div className="text-muted"> मैं पुष्टि करता/करती हूँ कि मैंने ऊपर दिए गए सभी निर्देश पढ़ लिये हैं और उनका पालन करने के लिए सहमत हूँ। { !hitBottom && <span>(बटन सक्षम करने के लिए नीचे तक स्क्रॉल करें)</span> }</div>
                  </label>
                </div>
                <div className="d-flex gap-2 w-100 w-sm-auto">
                  <button
                    type="button"
                    onClick={onClose}
                    className="btn btn-outline-secondary w-100 w-sm-auto"
                  >
                    Cancel
                  </button>
                  <button
                    type="button"
                    disabled={!canAgree}
                    onClick={onAgree}
                    className="btn btn-primary w-100 w-sm-auto"
                  >
                    Agree & Start
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="modal-backdrop fade show"></div>
    </>
  );
}
export default ExamInstructionsModal